import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { number } from 'prop-types';
import { StyledButtonGroup, GroupButtonLabel } from './styles';

/**
 * Renders MUI ButtonGroup to navigate between pages.
 * @returns { React.FC }
 */

const ViewSwitcher = ({ tab = 0 }) => {
  const location = useLocation();
  const { search } = location;

  const getBtnProps = tNumber => {
    const btnProps = {
      style: {
        backgroundColor: '#e6e6e6'
      }
    };
    if (tab !== tNumber) {
      const linkTo = tNumber === 0 ? '/device' : '/device-map';
      btnProps.component = Link;
      btnProps.to = `${linkTo}${search}`;
      btnProps.style.backgroundColor = 'inherit';
    }

    return btnProps;
  };

  return (
    <StyledButtonGroup
      size="small"
      aria-label="Toggle list/map"
    >
      <Button {...getBtnProps(0)}>
        <GroupButtonLabel>
          {' '}
          List
        </GroupButtonLabel>
      </Button>
      <Button {...getBtnProps(1)}>
        <GroupButtonLabel>
          {' '}
          Map
        </GroupButtonLabel>
      </Button>
    </StyledButtonGroup>
  );
};

ViewSwitcher.propTypes = {
  tab: number
};

export default ViewSwitcher;
